/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export const fileExtension = Object.freeze({
  PDF: 'pdf',
  XML: 'xml',
  ZIP: 'zip',
  JPEG: 'jpeg',
  JPG: 'jpg',
});
